export const transferEvents = {
    archiveList: 'ffl360_event_archive_list',
    resendTransferEmail: 'ffl360_event_resend_email',
    archive:'ffl360_event_archive_transfer',
    unarchive: 'ffl360_event_unarchive',
    downloadMasterProof: 'ffl360_event_dl_master_proof',
    reAssignDealer: 'ffl360_event_re_assign_dealer'
}

export const dealerEvents = {
    searchDealers: 'ffl360_event_search_dealers',
    cardView: 'ffl360_event_card_view', 
    mapView: 'ffl360_event_map_view',
    manualInitiateTransfer: 'ffl360_event_manual_initiate_t',
    sendProfileToDealer: 'ffl360_event_send_profile',
    ezCheckOnDealerProfile: 'ffl360_event_ezCheck_on_dp',
    previewLicense: 'ffl360_event_preview_license',
    previewSOT: 'ffl360_event_preview_sot',
    previewLOA: 'ffl360_event_preview_loa',
    editLicense: 'ffl360_event_edit_license',
    licenseUpload: 'ffl360_event_license_upload',
    editDealerContactDetails: 'ffl360_event_edit_details',
    editDealerSocialLinks: 'ffl360_event_edit_social_links',
    editDealerServices: 'ffl360_event_edit_services', 
    editDealerBusinessDescription: 'ffl360_event_edit_business_desc',
    editDealerSOT: 'ffl360_event_edit_dealer_sot',
    sotUpload: 'ffl360_event_sot_upload',
    loa_Upload: 'ffl360_event_loa_upload',
    editDealerOptIn: 'ffl360_event_edit_dealer_optin',
    showTransferCount: 'ffl360_event_show_count'
}

export const adminEvents = {
    editStoreProfile: 'ffl360_event_edit_store_p',
    addUser: 'ffl360_event_add_user',
    editUser: 'ffl360_event_edit_user',
    deleteUser: 'ffl360_event_delete_user',
    updateFFLSelectFiltersConfig: 'ffl360_event_update_fltrs_conf',
    updateFFLSelectStoreConfig: 'ffl360_event_update_store_conf',
    dealerAddedToBlacklist: 'ffl360_event_add_to_blacklist',
    dealerRemovedFromBlacklist: 'ffl360_event_removed_blacklist',
    updateDealerPreferredStatus: 'ffl360_event_update_preferred',
    updateDealerActionTimeout: 'ffl360_event_update_da_timeout',
    updateTermsAndConditions: 'ffl360_event_update_t_and_c'
}

export const analyticsEvents = {  
    userLoggedIn: 'ffl360_event_user_login',
    ...transferEvents,
    ...dealerEvents,
    ...adminEvents
};